import React, { ReactNode } from 'react';
import { useFormikContext, FormikContextType } from 'formik';
import { styled } from 'dripsy';
import { View } from 'react-native';

import { CheckBox, ICheckBoxProps } from '../common/CheckBox';
import { ErrorText } from './ErrorText';

const Container = styled(View)({});

const valueTransformer = (v: any): boolean => !!v;

export interface ICheckBoxFieldProps<T>
  extends Omit<ICheckBoxProps, 'onValueChange'> {
  name: string;
  onValueChange?: (
    formik: FormikContextType<T>,
    value: boolean,
  ) => void;
}

export function CheckBoxField<T extends Record<string, any>>({
  name,
  onValueChange,
  onLayout,
  ...props
}: ICheckBoxFieldProps<T>) {
  const formik = useFormikContext<T>();

  function onChange(value: boolean) {
    formik.setFieldValue(name, value);

    if (onValueChange) {
      onValueChange(formik, value);
    }
  }

  const value = valueTransformer(formik.values[name]);

  const error = formik.errors[name];

  const isError = !!(
    typeof error !== 'undefined' && formik.touched[name]
  );

  return (
    <Container onLayout={onLayout}>
      <CheckBox value={value} onValueChange={onChange} {...props} />
      {isError && <ErrorText>{error as ReactNode}</ErrorText>}
    </Container>
  );
}
